import { BudgetInterface } from "./budget-interface.model";

export interface Quotation {
    requestedItems: BudgetInterface;
    recommendedItems: BudgetInterface;
    complementaryBudget: BudgetInterface;
}